import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchCrossLibraryHistory } from "../api/crossLibraryService";
export var useCrossLibraryHistory = function (titleId, enabled) {
    var kyInstance = useOkapiKy();
    return useQuery(["cross-library-history", titleId], function () { return fetchCrossLibraryHistory(kyInstance, titleId); }, {
        enabled: enabled && Boolean(titleId),
        cacheTime: 60000,
    });
};
